import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemePramsContext } from '../../App';
import { StyledHtmlContent } from './HtmlContent.styled';

// Renders html that comes from the backend/CMS and gives tables inside it
// readable borders and paddings. Use `as` to keep the original tag
// (e.g. 'p') or to render through an existing styled wrapper.
// `children` is dropped on purpose: React cannot combine it with dangerouslySetInnerHTML.
// eslint-disable-next-line no-unused-vars
const HtmlContent = ({ html, as, tableConfig, children, ...rest }) => {
  const selectedConfig = useContext(ThemePramsContext);
  const resolvedTableConfig = tableConfig || selectedConfig?.blogConfig?.table;

  return (
    <StyledHtmlContent
      {...rest}
      as={as}
      $tableConfig={resolvedTableConfig}
      dangerouslySetInnerHTML={{ __html: html || '' }}
    />
  );
};

HtmlContent.propTypes = {
  html: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  tableConfig: PropTypes.object,
  className: PropTypes.string,
};

export default HtmlContent;
